<header *ngIf="(hideUI$ | async) !== true" class="ip-header">
	<div class="branding">
		<img src="/assets/certmetrics-no-tag.png">

		<div class="environment-banner" *ngIf="environment !== 'prod'">
			{{ environment }}
		</div>
	</div>
	<ip-client-toolbar></ip-client-toolbar>
	<div class="current-user">
		<span class="user-identity" *ngIf="(user$ | async) as user">
			{{ user.name }}
		</span>
		<span class="user-actions">
			<button mat-button cm-mini-button (click)="logout()">
				Sign Out
			</button>
		</span>
	</div>
</header>
<section [ngClass]="{'authenticated': (hideUI$ | async) !== true}">
	<ip-nav *ngIf="(hideUI$ | async) !== true"></ip-nav>
	<main>
		<ng-container *ngIf="(skipClientSelection$ | async); else requireClientMessage">
			<div class="view-container" cm-view-outlet>
				<router-outlet></router-outlet>
			</div>
		</ng-container>
	</main>
</section>
<footer class="ip-footer">
	<span class="sp-footer__copyright">&copy; 2019&ndash;{{footerDateCurrentYear}} Alpine Testing Inc.</span>
</footer>

<ng-template #requireClientMessage>
	<ip-client-required-selector></ip-client-required-selector>
</ng-template>
